<template>
    <div class="modal-reset">
        <div class="reset-title">
            <span class="gradient-green">{{ $t('modal.131') }}</span>
        </div>
        <div class="reset-element">
            <div class="element-title">{{ $t('modal.132') }}</div>
            <div class="element-content">
                <input v-model="modalPassword" type="password" placeholder="ENTER PASSWORD..." />
            </div>
        </div>
        <div class="reset-element">
            <div class="element-title">{{ $t('modal.133') }}</div>
            <div class="element-content">
                <input v-model="modalPasswordConfirm" type="password" placeholder="ENTER PASSWORD..." />
            </div>
        </div>
        <button v-on:click="modalResetButton()" class="button-reset">
            <div class="button-inner">{{ $t('modal.134') }}</div>
        </button>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: 'ModalReset',
        data() {
            return {
                modalPassword: null,
                modalPasswordConfirm: null
            }
        },
        methods: {
            ...mapActions([
                'notificationShow',
                'modalsSetShow',
                'modalsSetData'
            ]),
            modalResetButton() {
                if(this.modalPassword === null || this.modalPassword.trim() === '') {
                    this.notificationShow({ type: 'error', message: 'Your entered password is invalid.' });
                    return;
                }

                if(this.modalPassword !== this.modalPasswordConfirm) {
                    this.notificationShow({ type: 'error', message: 'Your entered passwords does not match.' });
                    return;
                }

                this.modalsSetData({ typeCaptcha: 'credentialsReset', data: { ...this.modalsData, password: this.modalPassword } });
                this.modalsSetShow(null);

                setTimeout(() => { this.modalsSetShow('Captcha'); }, 200);
            }
        },
        computed: {
            ...mapGetters([ 
                'modalsData'
            ])

        }
    }
</script>

<style scoped>
.modal-reset {
    width: 773px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 35px 80px 48px 80px;
    border-radius: 15px;
    background: var(--background);
}

/* Title */
.modal-reset .reset-title {
    text-align: center;
    font-size: 32px;
    font-weight: 900;
}

/* Elements */
.modal-reset .reset-element {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 35px;
}
.modal-reset .element-title {
    font-size: 14px;
    font-weight: 800;
    color: #bbbfd0;
}
.modal-reset .element-content {
    width: 100%;
    height: 72px;
    position: relative;
    margin-top: 20px;
    padding: 1px;
}
.modal-reset .element-content input {
    width: 100%;
    height: 100%;
    padding: 0 15px;
    font-size: 16px;
    font-weight: 600;
    color: #ffffff;
    background: var(--background2);
}
.modal-reset .element-content input::placeholder {
    color: #5e768e;
}

/* Button */
.modal-reset button.button-reset {
    width: 300px;
    height: 54px;
    margin-top: 35px;
}
.modal-reset button.button-reset .button-inner {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    font-weight: 800;
    color: #ffffff;
    background: var(--button1);
}

/* Tablet */
@media only screen and (max-width: 793px) {
    .modal-reset {
        width: calc(100vw - 20px);
        padding: 35px 10px 48px 10px;
    }
}

/* Mobil (bottom sheet) */
@media only screen and (max-width: 500px) {
    .modal-reset {
        width: 100vw;                  /* tam genişlik */
        max-width: 100%;
        border-radius: 20px 20px 0 0;  /* sadece üst köşeler */
        padding: 55px 15px 48px 15px;
    }

    .modal-reset button.button-reset {
        width: 100%; /* tam genişlik buton */
    }
}
</style>
